<template>
  <v-dialog width="500px" scrollable :value="app.inputBox">
    <v-card>
      <v-card-title v-if="app.inputBoxTitle">
        {{ app.inputBoxTitle }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-text-field hide-details dense outlined v-model="value"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <styled-button :disabled="!value" @click="submit">{{
          txt.submit
        }}</styled-button>
        <styled-button-light @click="cancel">{{ txt.cancel }}</styled-button-light>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { useLocalStore } from "../../store/local";
import { useAppStore } from "../../store/app";
import StyledButton from "./StyledButton.vue";
import StyledButtonLight from "./StyledButtonLight.vue";
import { ref, watch } from 'vue'

const txt = useLocalStore()
const app = useAppStore()
const value = ref('')

watch(()=>app.inputBox, (v) => {
  if(v) value.value = app.inputBoxValue
})

function submit() {
  if (app.inputBoxSuccess) app.inputBoxSuccess(value.value)
  app.inputBox = false
}

function cancel() {
  if (app.inputBoxCancel) app.inputBoxCancel(value.value)
  app.inputBox = false
}
</script>